import React, { useEffect, useState } from 'react'
import { take } from 'lodash-es'
import { useTranslation } from 'react-i18next'
import { Box, RowsSkeletonLoader } from '@node-space/ui-components'
import { MerchantType } from 'types/types'
import LatestMerchants from './LatestMerchants'
import LatestTransactions from './LatestTransactions'

type LatestActivityType = {
  isMerchantsLoading: boolean
  merchantList: MerchantType[]
}

export const LatestActivity = ({ isMerchantsLoading, merchantList }: LatestActivityType) => {
  const { t } = useTranslation()

  const LATEST_MERCHANTS_LIMIT = 4
  const latestMerchants = take(merchantList, LATEST_MERCHANTS_LIMIT)
  const hasMerchants = !!latestMerchants?.length

  const [selectedWalletId, setSelectedWalletId] = useState('')

  useEffect(() => {
    if (hasMerchants && !selectedWalletId) {
      const defaultWalletId = `${latestMerchants[0].wallet?.id}`
      setSelectedWalletId(defaultWalletId)
    }
  }, [merchantList])

  return (
    <Box flex flexCol paddingT={24} gapY={16}>
      <h2 className="text-h2 text-foreground-prominent">{t('latestActivity')}</h2>
      {isMerchantsLoading ? (
        <Box className="gap-0">
          <RowsSkeletonLoader rows={4} />
        </Box>
      ) : hasMerchants ? (
        <Box flex flexCol gapY={24}>
          <LatestMerchants
            merchants={latestMerchants}
            selectedId={selectedWalletId}
            onSelectMerchant={walletId => {
              setSelectedWalletId(walletId)
            }}
          />
          <h4 className="text-h4 text-foreground-prominent">
            {t('latestTransactions.description')}
          </h4>
          <LatestTransactions walletId={selectedWalletId} />
        </Box>
      ) : (
        <p className="text-foreground-subdued text-body-regular">
          {t('latestActivityDescription')}
        </p>
      )}
    </Box>
  )
}
